/**
 * Throttles a function to limit continous function calls.
 *
 * @param {function} func The function to be throttled.
 * @param {number} limit The limit to throttle function (in milisecond).
 * @returns {function} The resulted function after throttle is implemented.
 */

export default function throttle(func, limit) {
  let inThrottle;
  return function callback(_arguments) {
    const args = _arguments;
    const context = this;
    if (!inThrottle) {
      func.apply(context, args);
      inThrottle = true;
      setTimeout(() => {
        inThrottle = false;
      }, limit);
    }
  };
}
